import { render, staticRenderFns } from "./DownloadNotfis.vue?vue&type=template&id=00abac5a"
import script from "./DownloadNotfis.vue?vue&type=script&lang=js"
export * from "./DownloadNotfis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports